export function DefaultPageLayout(props){
    const{children}=props;
    return<>
        {children}
    </>
}